import { ToastService } from "@shared/lib/services";
import { AdminUser, BackednResponse } from "@shared/lib/types";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { ADMIN_LIST_QUERY_KEY } from "../constants/";
import { AdminService } from "../servcies/admin.service";

export function useGetAdmin(adminId: string, enabled: boolean = true) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<AdminUser>
  >({
    queryKey: [...ADMIN_LIST_QUERY_KEY, adminId],
    queryFn: () => AdminService.getAdmin(adminId),
    enabled: !!adminId && enabled,
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    admin: data?.data,
    isError,
    isFetching: isLoading,
  };
}
